import type { StateCreator } from 'zustand';
import type { Stats } from '../../types';
import { START_CASH } from '../../constants';
import { loadPersisted } from '../persist';
import type { GameState } from '../types';
import { preloadRewardAd } from '../../sdk/ads';

export interface PlayerSlice {
  cash: number;
  stats: Stats;
  init: () => void;
}

const initialStats: Stats = {
  maxCash: START_CASH,
  maxRet: 0,
  maxStreak: 0,
  streak: 0,
  liquidations: 0,
  totalTrades: 0,
  totalPlaySec: 0,
};

export const createPlayerSlice: StateCreator<GameState, [], [], PlayerSlice> = (set, get) => ({
  cash: START_CASH,
  stats: initialStats,

  init: () => {
    void (async () => {
      const persisted = await loadPersisted();
      set(persisted);
      const s = get();
      if (!s.disclaimerDone) {
        set({ tickPaused: true, showDisclaimerModal: true });
      } else if (!s.tutDone) {
        get().setTutStep(0);
      }
      // 광고 사전 로드 (토스 환경에서만 동작)
      preloadRewardAd();
    })();
  },
});
